// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pageLayout_wrapper__3sIeO","spin":"pageLayout_spin__2nkkK","layoutFill":"pageLayout_layoutFill__18XdU","layout":"pageLayout_layout__3feyQ"};